import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#019FE2',
    },
    secondary: {
      main: '#CC2783',
    },
    error: {
      main: '#803192',
    },
    background: {
      default: '#f4f6f8',
    },
    text: {
      primary: '#3B3B3D',
    },
  },
  typography: {
    fontFamily: 'Montserrat, Arial',
    h1: {
      fontFamily: 'Nunito, Arial',
      fontWeight: 700,
    },
    h2: {
      fontFamily: 'Nunito, Arial',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'Nunito, Arial',
      fontWeight: 700,
    },
    h4: {
      fontFamily: 'Nunito, Arial',
      fontWeight: 700,
    },
    h5: {
      fontFamily: 'Nunito, Arial',
      fontWeight: 700,
    },
    h6: {
      fontFamily: 'Nunito, Arial',
      fontWeight: 700,
    },
    body1: {
      fontFamily: 'Montserrat, Arial',
    },
    body2: {
      fontFamily: 'Montserrat, Arial',
    },
    button: {
      fontFamily: 'Montserrat, Arial',
      fontWeight: 700,
    },
  },
});

export default theme;
